import React, { useEffect, useState } from "react";
import DoctorCardField from "./DoctorCardFeild";
import axios from "axios";
import { API_URL } from "../../../../configs/endpoint";
import { Alert, Grid, Skeleton, Stack } from "@mui/material";

export default function ChooseDoctor({ control, handleNext }) {
  const [apiResponse, setApiResponse] = useState({
    loading: false,
    error: null,
    data: null,
  });

  useEffect(() => {
    if (!apiResponse?.data) {
      setApiResponse({ loading: true, error: null, data: null });
      axios
        .get(`${API_URL}/doctors`)
        .then((response) => {
          setApiResponse({ loading: false, error: null, data: response?.data });
        })
        .catch((error) => {
          setApiResponse({
            loading: false,
            error: error?.message || "Failed to fetch doctors",
            data: [],
          });
        });
    }
  }, [apiResponse?.data]);
  return (
    <Grid container spacing={3}>
      {apiResponse.loading ? (
        [1, 2, 3].map((i) => (
          <Grid item xs={12} sm={6} lg={3} key={i}>
            <Stack spacing={1} alignItems="center">
              {/* Avatar Skeleton */}
              <Skeleton variant="circular" width={90} height={90} />
              {/* Name Skeleton */}
              <Skeleton variant="text" width="80%" height={24} />
              {/* Speciality Skeleton */}
              <Skeleton variant="text" width="60%" height={18} />
            </Stack>
          </Grid>
        ))
      ) : apiResponse.error ? (
        <Alert severity="error">{apiResponse.error}</Alert>
      ) : (
        !apiResponse?.loading &&
        apiResponse?.data && (
          <DoctorCardField
            doctors={apiResponse?.data}
            control={control}
            name="doctor"
            handleNext={handleNext}
          />
        )
      )}
    </Grid>
  );
}
